module.exports = __webpack_public_path__ + "static/move_heatmap_landing-ffbca0e90f50ec93f354c01f1f65a003.jpg";